<template>
	<div>
		<Order v-for="(order) in orderList" :key="order.orderId" :orderId="order.orderId" :layoutList="true" />
	</div>
</template>

<script>
import { userMixin } from '@/mixins/userMixin';
import Order from './Order.vue';




export default {
	name: "OrderList",
	components: {
		Order
	},
	mixins: [userMixin],
	props: {
		orderId: Number,
	},
	data() {
		return {


		};
	},
	computed: {


	},
	methods: {




	}
};
</script>

<style scoped></style>